/* Cliente del companion para las propuestas de reescritura.
   El panel manda QUÉ colaborador y QUÉ texto; los mensajes (con el prompt del colaborador)
   se construyen en el companion. La API key también vive allí. */

import { COMPANION, companionError, providerError, recordarOp } from "./companion";

const ENDPOINT = `${COMPANION}/chat`;

export async function callAgent(
  agentId: string,
  instruction: string,
  text: string,
  contextFiles: string[],
  model: string,
  // Dónde está el libro. Sin esto el motor apuntaba la reescritura en su registro general y no en el del libro: el
  // certificado no podía decir «el autor decidió esto» de las reescrituras hechas desde el propio panel.
  donde: { saveDir?: string | null; docPath?: string | null } = {},
): Promise<string> {
  let res: Response;
  try {
    res = await fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ agent: agentId, instruction, text, contextFiles, model, saveDir: donde.saveDir || null, docPath: donde.docPath || null }),
    });
  } catch (netErr: any) {
    throw new Error(companionError(netErr));
  }
  if (!res.ok) {
    const t = await res.text().catch(() => "");
    throw new Error(providerError("Colaborador", res.status, t));
  }
  const data = await res.json();
  const content = data?.choices?.[0]?.message?.content;
  if (!content) throw new Error("Respuesta vacía del modelo");
  // El identificador de la operación viaja en la cabecera, no en el cuerpo: el cuerpo es la
  // respuesta cruda de OpenRouter y se parsea tal cual desde julio.
  recordarOp(content as string, res.headers.get("x-hi-op"));
  return content as string;
}
